// extracted by mini-css-extract-plugin
module.exports = {"mobileLandscapeOverlay":"MobileLandscapeOverlay_mobileLandscapeOverlay__FZRT-","mobileLandscapeOverlayDesktop":"MobileLandscapeOverlay_mobileLandscapeOverlayDesktop__327io"};